<template>
  <div class="dialog" @touchmove.prevent>
    <myMask v-if="dialog.mask & show"></myMask>

    <div class="dialogWin" v-show="show">
      <i v-if="showClose" class="close fs-18" v-on:click="close('close')">×</i>
      <slot name="topIcon"></slot>
      <div class="title fs-18" v-if="dialog.title.text != ''" :style="dialog.title.style">
        {{ dialog.title.text }}
      </div>
      <slot name="top"></slot>
      <div
        class="fs-16"
        v-if="dialog.content.text"
        v-bind:class="['content', dialog.title.text != '' ? '' : 'noTitle']"
        :style="dialog.content.style"
      >
        <div v-html="dialog.content.text"></div>
      </div>
      <slot name="content"></slot>
      <slot name="bottom"></slot>
      <div :class="[tomoreBtn ? 'other-action' : 'action']">
        <div class="btnCont" v-for="(item, index) in dialog.actions" :key="index">
          <div
            @click.stop="item.callBack"
            :class="[
              'btn',
              'fs-16',
              item.disabled ? 'disabled' : '',
              item.active ? 'btn--yellow' : '',
              freeStyleBtn ? '':QUESTIONS_TYPE != 5  ? 'btn--yellow' : 'btnvip--vip'
            ]"
            >{{ item.text }}</div
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
import myMask from './mask'
export default {
  components: {
    myMask
  },
  props: {
    propMask: {
      type: Boolean
    },
    propTitle: [String, Object],
    propContent: {
      type: [String, Object]
    },
    propActions: {
      type: Array
    },
    propTime: Number,
    showClose: {
      type: Boolean,
      default: true
    },
    propSlot: {
      type: Boolean,
      default: false
    },
    freeStyleBtn:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mask: true,
      title: '',
      content: '',
      actions: [],
      show: false
    }
  },
  mounted() {
    //            console.log(this.propActions[0].callBack);
  },
  computed: {
    ...mapGetters(['QUESTIONS_TYPE']),
    dialog() {
      const that = this
      const rs = {
        title: {},
        content: {},
        actions: []
      }
      rs.mask = that.propMask != undefined ? that.propMask : that.$data.mask
      if (that.propTitle != undefined) {
        if (typeof that.propTitle == 'string') {
          rs.title.text = that.propTitle != '' ? that.propTitle : ''
        } else {
          rs.title.text =
            that.propTitle.text != undefined ? that.propTitle.text : ''
          rs.title.style = that.propTitle.style
        }
      }

      if (!!that.propContent) {
        if (typeof that.propContent == 'string') {
          rs.content.text = that.propContent
          that.$data.show = true
        } else {
          rs.content.text = that.propContent.text
          rs.content.style = that.propContent.style
          that.$data.show = true
        }
      } else if (that.propSlot) {
        that.$data.show = true
      }

      if (that.propActions != undefined) {
        if (that.propActions.length > 0) {
          for (let i = 0; i < that.propActions.length; i++) {
            let temp = {}
            temp.text =
              that.propActions[i].text != undefined
                ? that.propActions[i].text + ''
                : '按钮' + i
            temp.active =
              that.propActions[i].active != undefined
                ? that.propActions[i].active
                : false
            temp.disabled =
              that.propActions[i].disabled != undefined
                ? that.propActions[i].disabled
                : false
            if (that.propActions[i].callBack != undefined) {
              temp.callBack = function() {
                if (temp.disabled) {
                  return false
                }
                that.propActions[i].callBack()
                that.close()
              }
            } else {
              temp.callBack = function() {
                that.close()
              }
            }
            rs.actions.push(temp)
          }
        } else {
          let temp = {}
          temp.text = '关闭'
          temp.callBack = that.close
          rs.actions.push(temp)
        }
      } else {
        let temp = {}
        temp.text = '关闭'
        temp.callBack = that.close
        rs.actions.push(temp)
      }
      return rs
    },
    tomoreBtn() {
      if (this.dialog.actions.length > 2) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    close(type) {
      this.show = false
      this.actions = []
      this.title = ''
      this.content = ''
      if (type) {
        this.$emit('myDialogClose', true)
      } else {
        this.$emit('myDialogClose')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$font-size-base: 75; // Base on 750px;
@function topx($rem) {
  @return $rem/$font-size-base;
}

.dialog {
  .dialogWin {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 8rem;
    height: auto;
    transform: translate(-50%, -50%);
    padding: topx(50rem) topx(40rem) topx(50rem) topx(40rem);
    background: #fff;
    z-index: 10;
    border-radius: topx(26rem);
    .close {
      position: absolute;
      top: topx(40rem);
      right: topx(40rem);
      font-style: normal;
      width: topx(44rem);
      height: auto;
      line-height: 1.22;
      /* font-size: 18px; */
      text-align: center;
    }
    .title {
      height: auto;
      line-height: 1.67;
      /* font-size: 18px; */
      text-align: center;
      margin: 0 topx(36rem);
      padding: topx(15rem) 0;
      font-weight: bold;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &.empty {
        height: topx(18rem);
        padding: 0;
      }
    }
    .content {
      margin: topx(20rem) 0 topx(40rem) 0;
      /* font-size: 16px; */
      line-height: 1.78;
      min-height: topx(114rem);
      color: #666;
      display: flex;
      align-items: center;
      div {
        flex: 1 1 0;
        text-align: center;
      }
      &.noTitle {
        margin-top: topx(60rem);
      }
    }
    .action {
      display: flex;
      .btnCont {
        flex: 1 1 0;
        text-align: center;
      }
      .btn {
        display: block;
        margin: 0 10px;
        width: auto;
        height: auto;
        line-height: 2.56;
        /* font-size: 16px; */
        &.disabled {
          background: #f6f6f6 !important;
          color: #999 !important;
        }
      }
    }
    .other-action {
      .btnCont {
        width: 70%;
        margin: 0 auto;
      }
      .btn {
        display: block;
        margin: 0 10px;
        width: auto;
        height: auto;
        line-height: 2.56;
        margin-bottom: topx(20rem);
        /* font-size: 16px; */
        &.disabled {
          background: #f6f6f6 !important;
          color: #999 !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/dialog.vue